/*
 * @Author: Huangxianlong
 * @Date: 2023-05-29 10:27:17
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2026-08-18 14:38:04
 * @FilePath: \monitor\src\api\config.js
 * @Description:
 */

var API_ROOT = "";
const emulateJSON = true;
if (process.env.NODE_ENV == "development") {
  //开发环境
  if (serverConfig.language == "EN") {
    // API_ROOT = "http://58.185.193.102:8081";
    // API_ROOT = "http://127.0.0.1:8081";
    API_ROOT = "http://192.168.0.104:8081";
  } else {
    // API_ROOT = "http://120.25.169.165:8083";
    // API_ROOT = "http://127.0.0.1:8083";
    API_ROOT = "http://192.168.0.104:8083";
    // API_ROOT = "http://192.168.0.109:8082";
  }
} else if (process.env.NODE_ENV == "production") {
  //生产环境
  if (serverConfig.language == "EN") {
    // API_ROOT = "http://58.185.193.102:8081";
    // 后端程序还是部署在8081，通过nginx通过661（https）代理到了8081
    // API_ROOT = "https://58.185.193.102:661";
    // API_ROOT = "https://app.sensingtech.info:661";
    // 后端程序还是部署在8081，通过nginx通过443（https）代理到了8081,需要加前缀 /prod
    API_ROOT = "https://app.sensingtech.info/prod";
  } else {
    // API_ROOT = "http://120.25.169.165:8083";
    // 后端程序还是部署在8003，通过nginx通过8003（https）代理到了8083
    API_ROOT = "https://120.25.169.165:8003";
  }
}
export { API_ROOT, emulateJSON, APP_ENV };



// WEBPACK FOOTER //
// ./src/api/config.js